import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import MCTopView from "@common/images/microcentrifuge_topview.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";
import { InteractionArea } from "./InteractionArea";

import "./style.scss";

export function LidOpen(props) {
  const { t } = useTranslation();
  const balancedText = props.balanced
    ? t("MicrocentrifugeBalanced.string")
    : t("MicrocentrifugeUnbalanced.string");

  const buildTubePositionString = (positions) => {
    const lengths = positions.length;
    const twelve = {
      1: 12,
      2: 1,
      3: 2,
      4: 3,
      5: 4,
      6: 5,
      7: 6,
      8: 7,
      9: 8,
      10: 9,
      11: 10,
      12: 11,
    };

    let str = "";
    for (let i = 0; i < positions.length; i++) {
      const shiftedPost = twelve[positions[i]];
      if (i === 0) {
        str += `${shiftedPost}`;
      } else if (i !== lengths - 1) {
        str += `, ${shiftedPost}`;
      } else {
        str += ` ${t("And.string")} ${shiftedPost}`;
      }
    }

    return str;
  };

  const slotReader = (slots) => {
    let slotsFound = 0;
    const positions = [];

    if (!slots) {
      return { slotsFound, positionString };
    }
    for (const slot of slots) {
      if (slot.solution) {
        slotsFound += 1;
        positions.push(slot.id);
      }
    }
    const positionString = buildTubePositionString(positions);
    return { slotsFound, positionString };
  };

  const { slotsFound, positionString } = slotReader(props.slots);

  const screenReaderText = `${t("ControlOpenTop.string")} ${balancedText} ${t(
    "MicrocentrifugePositionState.string",
    { slots: slotsFound, positions: positionString }
  )}`;

  return (
    <div className="mc_equipment_topview">
      <Image
        className="mc_equipment_topview_image"
        src={MCTopView}
        alt={screenReaderText}
      />
      <InteractionArea
        tabindex="0"
        className="mc_equipment_topview_interactionArea"
        onDrop={props.onDrop}
        slots={props.slots}
      />
    </div>
  );
}

LidOpen.propTypes = {
  /**
   * callback for when lid is clicked- open and close lid
   */
  toggleLid: PropTypes.func,
  /**
   * data of all slots
   * slot position start from 1 to 12 ; 1 being at' 12 0 clock' position and so on
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id of slot
       */
      id: PropTypes.number,
      /**
       * specifies if rotor is present
       */
      rotor: PropTypes.bool,
      /**
       * specifes if solution is present
       */
      tube: PropTypes.bool,
    })
  ),
  /**
   * callback function to trigger on drop
   */
  onDrop: PropTypes.func,
};
